app.service('agreementsSubmit', function (log, pageConfig) {
	var valuesBeforePost;
	var valuesOnPost;
	var $initForm;

	function changedAgreements() {
		return valuesOnPost.filter(function (element, i) {
			return valuesBeforePost[i].value != element.value;
		}).map(function (element, i) {
			var value = valuesBeforePost.filter(function (e) {
				return element.name == e.name;
			})[0].value;
			if (element.name == 'PERMISSION_TO_ELECTRONIC_CHANNEL' && element.value == false) {
				localStorage.setItem('permissions-minimalize', true);
			}
			return element.name + ": " + value + ' => ' + element.value;
		}).join(", ");
	}
	function allAgreements() {
		return valuesOnPost.map(function (element, i) {
			return element.name + ': ' + element.value
		}).join(", ");
	}

	function submitAgreementsForm() {
		valuesOnPost = agreementStatus();
		log.event({
			'id': 'agreements-form',
			'f03': document.location.pathname,
			'f04': JSON.stringify(valuesOnPost) != JSON.stringify(valuesBeforePost),
			'f05': changedAgreements(),
			'f06': allAgreements(),
			'f07': getLoggedUserId(), // id zalogowanego użytkownika lub puste
			'f08': getLoggedUserEmail(), // email zalogowanego użytkownika
			'f09': getFormEmail(), // email z formularza
			'f10': getFormName() // identyfikator lub nazwa formularza
		});
	}

	function getFormName() {
		return $initForm.attr('action') || $initForm.attr('id');
	}
	function getLoggedUserId() {
		return pageConfig.getData('order').accountUserData ? pageConfig.getData('order').accountUserData.id : '';
	}
	function getLoggedUserEmail() {
		return pageConfig.getData('order').accountUserData ? pageConfig.getData('order').accountUserData.email : '';
	}
	function getFormEmail() {
		return $initForm.find('input[type="email"]') ? $initForm.find('input[type="email"]').val() : '';
	}

	function agreementStatus() {
		var result = [];
		$inputs.each(function () {
			const $element = $(this);
			const data = ($element.data('types') || "").split('|');
			const checked = $element.prop('checked');
			data.forEach(function (type) {
				result.push({
					'name': type,
					'value': checked
				});
			});
		});
		return result;
	}


	function init($form, $checkboxes) {
		if ($checkboxes && $form && $checkboxes.length && $form.length) {
			$inputs = $checkboxes;
			$initForm = $form;
			valuesBeforePost = agreementStatus();
			$form.submit(function () {
				if ($form.valid()) {
					submitAgreementsForm();
				}
			});
		}
	}

	return {
		init
	}
});